<template>
  <div>
    <el-header height="auto" style="padding:0;">
      <el-tabs type="border-card" v-model="form.dimension">
        <el-tab-pane label="快手" name="ks">
          <el-tabs v-model="form.type" @tab-click="tabclick">
            <el-tab-pane label="提升应用安装" name="2"></el-tab-pane>
            <!-- <el-tab-pane label="获取电商下单" name="3"></el-tab-pane>
            <el-tab-pane label="推广品牌活动" name="4"></el-tab-pane>-->
            <el-tab-pane label="搜集销售线索" name="5"></el-tab-pane>
            <!-- <el-tab-pane label="提高应用活跃" name="7"></el-tab-pane> -->
            <!-- <el-tab-pane label="商品推广" name="9"></el-tab-pane>
            <el-tab-pane label="直播推广" name="16"></el-tab-pane>-->
          </el-tabs>
          <el-form
            style="margin-bottom: 20px;"
            :inline="true"
            :size="size"
            class="demo-form-inline"
          >
            <el-form-item>
              <el-select
                filterable
                remote
                reserve-keyword
                :remote-method="remoteMethodAccount"
                placeholder="全部账户"
                clearable
                v-model="form.advertiser_id"
              >
                <el-option-group
                  v-for="group in  options.account_options"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <template slot="append" icon="el-icon-search">搜索</template>
              <el-input v-model="form.name" placeholder="请输入渠道名称或ID"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleSearch('1')">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="ks_content">
            <div class="ks_toolbar" style="margin-bottom:10px;">
              <p class="title">
                渠道列表
                <span>
                  有
                  <i class="el-icon-warning-outline"></i>标识说明信息不全，需补全监测链接等信息才能投放
                </span>
              </p>
              <p>
                <el-button type="primary" :size="size" @click="addKsInfo">新建渠道</el-button>
              </p>
            </div>
            <el-table
              border
              :data="tableData.data"
              :header-cell-style="{background:'#f5f7fa'}"
              style="width: 100%"
              v-loading="loading"
            >
              <el-table-column align="center" prop="place_name" label="渠道名称" width="250"></el-table-column>
              <el-table-column align="center" prop="place_name_other" label="渠道别名" width="200"></el-table-column>
              <el-table-column align="center" prop="advertiser_id" label="广告账户" width="200"></el-table-column>

              <!-- 提升应用安装 -->
              <template v-if="form.type == '2'">
                <el-table-column label="APP类型" width="auto">
                  <template slot-scope="scope">
                    <el-tag :size="size" v-if="scope.row.app_type == 'ANDROID'">安卓</el-tag>
                    <el-tag :size="size" v-if="scope.row.app_type == 'IOS'">IOS</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item,index) in yinyongFields"
                  :key="index"
                  :prop="item.value"
                  :label="item.fieldName"
                  :width="item.width"
                ></el-table-column>
                <!-- <el-table-column align="center"
                                    prop="codeType"
                                    label="动态编码"
                                    width="150">
                                    <template slot-scope="scope">
                                        <el-tag :size="size" v-if="scope.row.codeType == 'ADGROUP'">按广告组</el-tag>
                                        <el-tag :size="size" v-if="scope.row.codeType == 'CAMPAIGN'">按广告计划</el-tag>
                                    </template>
                </el-table-column>-->
                <el-table-column label="监测链接" width="300px">
                  <template slot-scope="scope">
                    <el-popover
                      placement="top-start"
                      title="监测链接"
                      width="300"
                      trigger="hover"
                      :content="scope.row.live_track_url"
                    >
                      <div
                        slot="reference"
                        style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap"
                      >{{scope.row.live_track_url}}</div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="editPlace(scope.row.id,'addForm','drawer')"
                    >编辑</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="copyPlace(scope.row.id)"
                    >复制</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="delPlace(scope.row.id)"
                    >删除</el-link>
                  </template>
                </el-table-column>
              </template>

              <!-- 搜集销售线索 -->
              <template v-if="form.type == '5'">
                <el-table-column label="投放范围" width="auto">
                  <template slot-scope="scope">
                    <el-tag :size="size" v-if="scope.row.other.scope_type == 'NONE'">默认</el-tag>
                    <el-tag :size="size" v-if="scope.row.other.scope_type == 'KS'">快手联盟广告</el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  v-for="(item,index) in xiaosouFields"
                  :key="index"
                  :prop="item.value"
                  :label="item.fieldName"
                  :width="item.width"
                ></el-table-column>

                <el-table-column fixed="right" label="操作" width="auto">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="editPlace(scope.row.id,'xsForm','xsDrawer')"
                    >编辑</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="copyPlace(scope.row.id)"
                    >复制</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="delPlace(scope.row.id)"
                    >删除</el-link>
                  </template>
                </el-table-column>
              </template>

              <!-- 应用活跃 -->
              <template v-if="form.type == '7'">
                <el-table-column label="APP类型" width="auto">
                  <template slot-scope="scope">
                    <el-tag :size="size" v-if="scope.row.app_type == 'ANDROID'">安卓</el-tag>
                    <el-tag :size="size" v-if="scope.row.app_type == 'IOS'">IOS</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item,index) in huoyueFields"
                  :key="index"
                  :prop="item.value"
                  :label="item.fieldName"
                  :width="item.width"
                ></el-table-column>
                <!-- <el-table-column align="center"
                                prop="codeType"
                                label="动态编码"
                                width="150">
                                    <template slot-scope="scope">
                                        <el-tag :size="size" v-if="scope.row.codeType == 'ADGROUP'">按广告组</el-tag>
                                        <el-tag :size="size" v-if="scope.row.codeType == 'CAMPAIGN'">按广告计划</el-tag>
                                    </template>
                </el-table-column>-->
                <el-table-column fixed="right" label="操作" width="auto">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="editPlace(scope.row.id,'yyForm','yyDrawer')"
                    >编辑</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="copyPlace(scope.row.id)"
                    >复制</el-link>
                    <el-link
                      type="primary"
                      style="margin-right:20px"
                      @click="delPlace(scope.row.id)"
                    >删除</el-link>
                  </template>
                </el-table-column>
              </template>
            </el-table>
            <el-row>
              <el-col :span="24">
                <el-pagination
                  background
                  @current-change="handleCurrentChange"
                  :current-page="tableData.page | number"
                  :page-size="tableData.rows | number"
                  layout="total, prev, pager, next, jumper"
                  :total="tableData.total | number"
                ></el-pagination>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="测试版块">测试版块</el-tab-pane> -->
      </el-tabs>
    </el-header>

    <!-- 新建渠道 -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="45%"
      direction="rtl"
      custom-class="k-drawer"
    >
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form
            :size="size"
            ref="addForm"
            :model="addForm"
            :rules="rules.addRules"
            label-width="100px"
          >
            <el-form-item label="渠道名称" prop="place_name">
              <el-input v-model="addForm.place_name" placeholder="请填写渠道名称"></el-input>
            </el-form-item>
            <el-form-item prop="place_name_other">
              <span slot="label">
                <el-tooltip
                  class="item"
                  content="设置渠道别名后，可在创建时，计划与广告组名称中，选择渠道别名动态词包，将渠道别名应用于广告名称中"
                  placement="top"
                >
                  <span>
                    <i class="el-icon-question"></i>渠道别名
                  </span>
                </el-tooltip>
              </span>
              <el-input v-model="addForm.place_name_other" placeholder="请填写渠道别名"></el-input>
            </el-form-item>
            <el-form-item label="广告账户" prop="advertiser_id">
              <el-select
                @change="getApplicationInfo"
                v-model="addForm.advertiser_id"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请输入广告账户名称或ID"
                :remote-method="remoteMethodAccount"
                :loading="loading"
              >
                <el-option-group
                  v-for="group in  options.account_options"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="APP类型" prop="app_type">
              <el-select v-model="addForm.app_type" placeholder="请选择APP类型">
                <el-option label="安卓" value="ANDROID"></el-option>
                <el-option label="IOS" value="IOS"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择应用">
              <el-select
                v-model="addForm.application"
                filterable
                placeholder="请选择应用"
                clearable
                @change="getPageInfo"
              >
                <el-option
                  v-for="item in options.application_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template v-if="addForm.app_type == 'ANDROID'">
                <p>
                  <el-checkbox v-model="addForm.isAppDownload" label="YES">优先从系统应用商店下载</el-checkbox>
                </p>
                <p v-if="addForm.isAppDownload.length > 0">
                  <el-checkbox-group v-model="addForm.app">
                    <el-checkbox label="huawei">华为</el-checkbox>
                    <el-checkbox label="oppo">OPPO</el-checkbox>
                    <el-checkbox label="vivo">VIVO</el-checkbox>
                    <el-checkbox label="xiaomi">小米</el-checkbox>
                    <el-checkbox label="meizu">魅族</el-checkbox>
                    <el-checkbox label="smartisan">锤子</el-checkbox>
                  </el-checkbox-group>
                </p>
              </template>
            </el-form-item>
            <el-form-item label="转化目标">
              <el-button type="primary" @click="openGoal('addForm')">选择转化目标</el-button>
            </el-form-item>
            <el-form-item label="关联小说">
              <el-radio-group v-model="addForm.isNovel" @change="getNovelInfo('addForm')">
                <el-radio-button label="YES">开启</el-radio-button>
                <el-radio-button label="NO">关闭</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择关联小说" v-if="addForm.isNovel == 'YES'">
              <el-select v-model="addForm.novel" filterable placeholder="请选择关联小说">
                <el-option
                  v-for="item in options.novel_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-link style="margin-left:15px" type="primary" @click="getNovelInfo('addForm')">去刷新</el-link>
            </el-form-item>
            <el-form-item label="下载详情页" v-if="addForm.application">
              <el-select v-model="addForm.page" filterable placeholder="请选择下载详情页" clearable>
                <el-option
                  v-for="item in options.page_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="live_track_url">
              <span slot="label">
                <el-tooltip class="item" content="创建渠道的监测链接" placement="top">
                  <span>
                    <i class="el-icon-question"></i>点击监测链接
                  </span>
                </el-tooltip>
              </span>
              <el-input
                v-model="addForm.live_track_url"
                placeholder="请填写点击监测链接"
                @blur="handleInputBlur"
              ></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'addForm','live_track_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <el-form-item label="ActionBar点击监测链接" prop="actionbar_click_url">
              <el-input
                v-model="addForm.actionbar_click_url"
                placeholder="请填写ActionBar点击监测链接"
                @blur="handleInputBlur"
              ></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'addForm','actionbar_click_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <!-- <el-form-item label="直达链接" prop="url">
                        <el-input v-model="addForm.url" placeholder="请填写直达链接"></el-input>
            </el-form-item>-->
            <!-- <el-form-item prop="run_type">
                        <span slot="label">
                            <el-tooltip class="item" content="动态链接" placement="top">
                                <span><i class="el-icon-question"></i>动态链接</span>
                            </el-tooltip>
                        </span>
                        <el-select v-model="addForm.run_type" placeholder="请选择链接">
                            <el-option label="无" value="NO"></el-option>
                            <el-option label="动态监测链接" value="RUN"></el-option>
                        </el-select>
            </el-form-item>-->
            <!-- <el-form-item v-if="addForm.run_type == 'RUN'">
                        <span slot="label">
                            <el-tooltip class="item" content="动态编码" placement="top">
                                <span><i class="el-icon-question"></i>动态编码</span>
                            </el-tooltip>
                        </span>
                        <el-input v-model="addForm.code" placeholder="请填写动态编码"></el-input>
            </el-form-item>-->
            <!-- <el-form-item label="动态编码累计方式" >
                        <el-radio-group v-model="addForm.codeType">
                            <el-radio-button label="ADGROUP">按广告组累加</el-radio-button>
                            <el-radio-button label="CAMPAIGN">按计划累加</el-radio-button>
                        </el-radio-group>
            </el-form-item>-->
          </el-form>
          <div class="demo-drawer__footer">
            <el-button @click="drawer = false" :size="size">取 消</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="submitInfo('addForm','drawer')"
            >{{ loading ? '提交中 ...' : '确 定' }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-drawer>
    <!-- 搜集线索渠道 -->
    <el-drawer
      :title="title"
      :visible.sync="xsDrawer"
      size="45%"
      direction="rtl"
      custom-class="k-drawer"
    >
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form
            :size="size"
            ref="xsForm"
            :model="xsForm"
            :rules="rules.xsRules"
            label-width="100px"
          >
            <el-form-item label="渠道名称" prop="place_name">
              <el-input v-model="xsForm.place_name" placeholder="请填写渠道名称"></el-input>
            </el-form-item>
            <el-form-item prop="place_name_other">
              <span slot="label">
                <el-tooltip
                  class="item"
                  content="设置渠道别名后，可在创建时，计划与广告组名称中，选择渠道别名动态词包，将渠道别名应用于广告名称中"
                  placement="top"
                >
                  <span>
                    <i class="el-icon-question"></i>渠道别名
                  </span>
                </el-tooltip>
              </span>
              <el-input v-model="xsForm.place_name_other" placeholder="请填写渠道别名"></el-input>
            </el-form-item>
            <el-form-item label="广告账户" prop="advertiser_id">
              <el-select
                @change="getApplicationInfo"
                v-model="xsForm.advertiser_id"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请输入广告账户名称或ID"
                :remote-method="remoteMethodAccount"
                :loading="loading"
              >
                <el-option-group
                  v-for="group in  options.account_options"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="投放范围" prop="scope_type">
                        <el-select v-model="xsForm.scope_type" placeholder="请选择投放范围">
                            <el-option label="默认" value="NONE"></el-option>
                            <el-option label="快手联盟广告" value="KS"></el-option>
                        </el-select>
            </el-form-item>-->
            <!-- <el-form-item label="转化途径" prop="url_type">
                        <el-select v-model="xsForm.url_type" placeholder="请选择转化途径">
                            <el-option label="默认链接" value="NONE"></el-option>
                            <el-option label="链接" value="URL"></el-option>
                            <el-option label="落地页" value="PAGE_URL"></el-option>
                        </el-select>
            </el-form-item>-->
            <!-- <el-form-item label="默认链接" prop="page_url" v-if="xsForm.url_type == 'NONE'">
            <el-input v-model="xsForm.page_url" placeholder="请输入默认链接"></el-input>-->
            <!-- <p><el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'zhForm','url')">{{tag}}</el-link></p> -->
            <!-- <p><el-checkbox v-model="xsForm.isPage" label="YES">是否使用落地页前置功能</el-checkbox></p> -->
            <!-- </el-form-item> -->
            <!-- <el-form-item label="链接" prop="page_url" v-if="xsForm.url_type == 'URL'">
            <el-input v-model="xsForm.page_url" placeholder="请输入链接"></el-input>-->
            <!-- <p><el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'zhForm','url')">{{tag}}</el-link></p> -->
            <!-- <p><el-checkbox v-model="xsForm.isPage" label="YES">是否使用落地页前置功能</el-checkbox></p> -->
            <!-- </el-form-item> -->
            <el-form-item label="落地页" prop="page_url">
              <el-input v-model="xsForm.page_url" placeholder="请输入落地页链接"></el-input>
              <!-- <p><el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'zhForm','url')">{{tag}}</el-link></p> -->
              <!-- <p><el-checkbox v-model="xsForm.isPage" label="YES">是否使用落地页前置功能</el-checkbox></p> -->
            </el-form-item>
            <el-form-item label="转化目标">
              <el-button type="primary" @click="openGoal('xsForm')">选择转化目标</el-button>
            </el-form-item>
            <el-form-item label="关联小说">
              <el-radio-group v-model="xsForm.isNovel" @change="getNovelInfo('xsForm')">
                <el-radio-button label="YES">开启</el-radio-button>
                <el-radio-button label="NO">关闭</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择关联小说" v-if="addForm.isNovel == 'YES'">
              <el-select v-model="xsForm.novel" filterable placeholder="请选择关联小说">
                <el-option
                  v-for="item in options.novel_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-link style="margin-left:15px" type="primary" @click="getNovelInfo('xsForm')">去刷新</el-link>
            </el-form-item>
            <el-form-item prop="live_track_url">
              <span slot="label">
                <el-tooltip class="item" content="创建渠道的监测链接" placement="top">
                  <span>
                    <i class="el-icon-question"></i>监测链接
                  </span>
                </el-tooltip>
              </span>
              <el-input
                v-model="xsForm.live_track_url"
                placeholder="请填写监测链接"
                @blur="handleInputBlur"
              ></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'zhForm','live_track_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <!-- <el-form-item label="ActionBar点击监测链接" prop="actionbar_click_url">
            <el-input v-model="xsForm.actionbar_click_url" placeholder="请填写ActionBar点击监测链接" @blur="handleInputBlur"></el-input>-->
            <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'zhForm','actionbar_click_url')">{{tag}}</el-link>
            </p>-->
            <!-- </el-form-item> -->
            <!-- <el-form-item prop="run_type">
                        <span slot="label">
                            <el-tooltip class="item" content="动态链接" placement="top">
                                <span><i class="el-icon-question"></i>动态链接</span>
                            </el-tooltip>
                        </span>
                        <el-select v-model="xsForm.run_type" placeholder="请选择链接">
                            <el-option label="无" value="NO"></el-option>
                            <el-option label="动态监测链接" value="RUN"></el-option>
                        </el-select>
            </el-form-item>-->
            <!-- <el-form-item v-if="xsForm.run_type == 'RUN'">
                        <span slot="label">
                            <el-tooltip class="item" content="动态编码" placement="top">
                                <span><i class="el-icon-question"></i>动态编码</span>
                            </el-tooltip>
                        </span>
                        <el-input v-model="xsForm.code" placeholder="请填写动态编码"></el-input>
            </el-form-item>-->
            <!-- <el-form-item label="动态编码累计方式" >
                        <el-radio-group v-model="xsForm.codeType">
                            <el-radio-button label="ADGROUP">按广告组累加</el-radio-button>
                            <el-radio-button label="CAMPAIGN">按计划累加</el-radio-button>
                        </el-radio-group>
            </el-form-item>-->
          </el-form>
          <div class="demo-drawer__footer">
            <el-button @click="xsDrawer = false" :size="size">取 消</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="submitInfo('xsForm','xsDrawer')"
            >{{ loading ? '提交中 ...' : '确 定' }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-drawer>
    <!-- 应用渠道 -->
    <el-drawer
      :title="title"
      :visible.sync="yyDrawer"
      size="45%"
      direction="rtl"
      custom-class="k-drawer"
    >
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form
            :size="size"
            ref="yyForm"
            :model="yyForm"
            :rules="rules.yyRules"
            label-width="100px"
          >
            <el-form-item label="渠道名称" prop="place_name">
              <el-input v-model="yyForm.place_name" placeholder="请填写渠道名称"></el-input>
            </el-form-item>
            <el-form-item prop="place_name_other">
              <span slot="label">
                <el-tooltip
                  class="item"
                  content="设置渠道别名后，可在创建时，计划与广告组名称中，选择渠道别名动态词包，将渠道别名应用于广告名称中"
                  placement="top"
                >
                  <span>
                    <i class="el-icon-question"></i>渠道别名
                  </span>
                </el-tooltip>
              </span>
              <el-input v-model="yyForm.place_name_other" placeholder="请填写渠道别名"></el-input>
            </el-form-item>
            <el-form-item label="广告账户" prop="advertiser_id">
              <el-select
                @change="getApplicationInfo"
                v-model="yyForm.advertiser_id"
                filterable
                remote
                reserve-keyword
                clearable
                placeholder="请输入广告账户名称或ID"
                :remote-method="remoteMethodAccount"
                :loading="loading"
              >
                <el-option-group
                  v-for="group in  options.account_options"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="APP类型" prop="app_type">
              <el-select v-model="yyForm.app_type" placeholder="请选择APP类型">
                <el-option label="安卓" value="ANDROID"></el-option>
                <el-option label="IOS" value="IOS"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择应用">
              <el-select
                v-model="yyForm.application"
                filterable
                placeholder="请选择应用"
                clearable
                @change="getPageInfo"
              >
                <el-option
                  v-for="item in options.application_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <template v-if="yyForm.app_type == 'ANDROID'">
                <p>
                  <el-checkbox v-model="yyForm.isAppDownload" label="YES">优先从系统应用商店下载</el-checkbox>
                </p>
                <p v-if="addForm.isAppDownload.length > 0">
                  <el-checkbox-group v-model="yyForm.app">
                    <el-checkbox label="huawei">华为</el-checkbox>
                    <el-checkbox label="oppo">OPPO</el-checkbox>
                    <el-checkbox label="vivo">VIVO</el-checkbox>
                    <el-checkbox label="xiaomi">小米</el-checkbox>
                    <el-checkbox label="meizu">魅族</el-checkbox>
                    <el-checkbox label="smartisan">锤子</el-checkbox>
                  </el-checkbox-group>
                </p>
              </template>
            </el-form-item>
            <el-form-item label="转化目标">
              <el-button type="primary" @click="openGoal('yyForm')">选择转化目标</el-button>
            </el-form-item>
            <el-form-item label="关联小说">
              <el-radio-group v-model="yyForm.isNovel" @change="getNovelInfo('xsForm')">
                <el-radio-button label="YES">开启</el-radio-button>
                <el-radio-button label="NO">关闭</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="选择关联小说" v-if="yyForm.isNovel == 'YES'">
              <el-select v-model="yyForm.novel" filterable placeholder="请选择关联小说">
                <el-option
                  v-for="item in options.novel_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-link style="margin-left:15px" type="primary" @click="getNovelInfo('yyForm')">去刷新</el-link>
            </el-form-item>
            <el-form-item label="下载详情页" v-if="yyForm.application">
              <el-select v-model="yyForm.page" filterable placeholder="请选择下载详情页" clearable>
                <el-option
                  v-for="item in options.page_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="live_track_url">
              <span slot="label">
                <el-tooltip class="item" content="创建渠道的监测链接" placement="top">
                  <span>
                    <i class="el-icon-question"></i>监测链接
                  </span>
                </el-tooltip>
              </span>
              <el-input
                v-model="yyForm.live_track_url"
                placeholder="请填写监测链接"
                @blur="handleInputBlur"
              ></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'yyForm','live_track_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <el-form-item label="ActionBar点击监测链接" prop="actionbar_click_url">
              <el-input
                v-model="yyForm.actionbar_click_url"
                placeholder="请填写ActionBar点击监测链接"
                @blur="handleInputBlur"
              ></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'yyForm','actionbar_click_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <el-form-item label="调起链接" prop="dq_url">
              <el-input v-model="yyForm.dq_url" placeholder="请填写调起链接" @blur="handleInputBlur"></el-input>
              <!-- <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'yyForm','dq_url')">{{tag}}</el-link>
              </p>-->
            </el-form-item>
            <!-- <el-form-item label="H5链接" prop="h5_url">
                        <el-input v-model="yyForm.h5_url" placeholder="请填写H5链接" @blur="handleInputBlur"></el-input>
                        <p>
                            <el-link :size="size" style="margin-right: 8px;" icon="el-icon-plus" v-for="tag in options.dynamicTags" :key="tag" type="info" @click="addToText(tag,'yyForm','h5_url')">{{tag}}</el-link>
                        </p>
            </el-form-item>-->
            <!-- <el-form-item prop="run_type">
                        <span slot="label">
                            <el-tooltip class="item" content="动态链接" placement="top">
                                <span><i class="el-icon-question"></i>动态链接</span>
                            </el-tooltip>
                        </span>
                        <el-select v-model="yyForm.run_type" placeholder="请选择链接">
                            <el-option label="无" value="NO"></el-option>
                            <el-option label="动态监测链接" value="RUN"></el-option>
                        </el-select>
            </el-form-item>-->
            <!-- <el-form-item v-if="yyForm.run_type == 'RUN'">
                        <span slot="label">
                            <el-tooltip class="item" content="动态编码" placement="top">
                                <span><i class="el-icon-question"></i>动态编码</span>
                            </el-tooltip>
                        </span>
                        <el-input v-model="yyForm.code" placeholder="请填写动态编码"></el-input>
            </el-form-item>-->
            <!-- <el-form-item label="动态编码累计方式" >
                        <el-radio-group v-model="yyForm.codeType">
                            <el-radio-button label="ADGROUP">按广告组累加</el-radio-button>
                            <el-radio-button label="CAMPAIGN">按计划累加</el-radio-button>
                        </el-radio-group>
            </el-form-item>-->
          </el-form>
          <div class="demo-drawer__footer">
            <el-button @click="yyDrawer = false" :size="size">取 消</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="submitInfo('yyForm','yyDrawer')"
            >{{ loading ? '提交中 ...' : '确 定' }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-drawer>
    <!-- 复制渠道 -->
    <el-dialog title="复制渠道" :visible.sync="copyDialog" width="30%">
      <el-form
        :model="copyForm"
        :rules="rules.copyRules"
        :size="size"
        ref="copyForm"
        label-width="80px"
      >
        <el-form-item label="渠道名称" prop="place_name">
          <el-input placeholder="请输入渠道名称" v-model="copyForm.place_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="渠道别名" prop="place_name_other">
          <el-input placeholder="请输入渠道别名" v-model="copyForm.place_name_other" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="copyDialog = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="copyAction('copyForm')" :size="size">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 转化目标 -->
    <el-dialog title="选择转化目标" :visible.sync="goalDialog">
      <el-form :model="zhForm" :rules="rules.zhRules" :size="size" label-width="80px" ref="zhForm">
        <el-form-item label="追踪方式" prop="follow">
          <el-radio-group v-model="zhForm.follow" @change="getZhuanhuaInfo">
            <el-radio-button label="API">API回传</el-radio-button>
            <el-radio-button label="SDK">SDK</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择转化" prop="changes">
          <el-select
            v-model="zhForm.changes"
            filterable
            placeholder="请选择转化目标"
            :loading="loading"
            clearable
          >
            <el-option
              v-for="item in options.changes_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="canelGoal" :size="size">取 消</el-button>
        <el-button type="primary" @click="addGoal('zhForm')" :size="size">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formName: '',
      title: '新建渠道',
      copyDialog: false,
      goalDialog: false,
      drawer: false,
      yyDrawer: false,
      xsDrawer: false,
      loading: false,
      size: 'mini',
      pageTitle: '快手渠道',
      selectionStart: '',
      // 提升应用维度表头
      yinyongFields: [
        { value: 'changes_name', fieldName: '转化目标', width: '150' },
        { value: 'application_name', fieldName: '应用目标', width: '150' }
        // {value:'live_track_url',fieldName:'监测链接',width:'200'},
      ],
      // 销售线索维度表头
      xiaosouFields: [
        { value: 'other.page_url', fieldName: '落地页/商品', width: '200' },
        { value: 'live_track_url', fieldName: '监测链接', width: '200' }
      ],
      // 应用活跃维度表头
      huoyueFields: [
        { value: 'changes_name', fieldName: '转化目标', width: '100' },
        { value: 'application_name', fieldName: '应用目标', width: '100' },
        { value: 'other.live_track_url', fieldName: '监测链接', width: '100' }
      ],
      // 下拉数据
      options: {
        account_options: [],
        application_options: [],
        changes_options: [],
        novel_options: [],
        dynamicTags: ['动态编码', '广告计划序号', '广告组序号'],
        page_options: []
      },
      // 搜索栏form
      form: {
        dimension: 'ks',
        type: '2',
        advertiser_id: '',
        name: ''
      },
      // 追踪form
      zhForm: {
        follow: 'API',
        changes: ''
      },
      // 复制form
      copyForm: {
        place_name: '',
        place_name_other: ''
      },
      copyId: '',
      // 提升应用form
      addForm: {
        type: '2',
        advertiser_id: '',
        place_name: '',
        place_name_other: '',
        app_type: '',
        application: '',
        application_name: '',
        isAppDownload: [],
        app: [],
        follow: '',
        changes: '',
        changes_name: '',
        isNovel: 'NO',
        novel: '',
        live_track_url: '',
        actionbar_click_url: '',
        page: '',
        page_url: '',
        url: '',
        run_type: 'NO',
        code: '',
        codeType: 'ADGROUP'
      },
      // 应用活跃form
      yyForm: {
        type: '7',
        advertiser_id: '',
        place_name: '',
        place_name_other: '',
        app_type: '',
        application: '',
        application_name: '',
        isAppDownload: [],
        app: [],
        follow: '',
        changes: '',
        changes_name: '',
        isNovel: 'NO',
        novel: '',
        live_track_url: '',
        actionbar_click_url: '',
        page: '',
        dq_url: '',
        h5_url: '',
        run_type: 'NO',
        code: '',
        codeType: 'ADGROUP'
      },
      // 销售线索form
      xsForm: {
        type: '5',
        advertiser_id: '',
        place_name: '',
        place_name_other: '',
        // scope_type:'NONE',
        url_type: 'NONE',
        page_url: '',
        isPage: [],
        follow: '',
        changes: '',
        changes_name: '',
        isNovel: 'NO',
        novel: '',
        live_track_url: '',
        actionbar_click_url: '',
        run_type: 'NO',
        code: '',
        codeType: 'ADGROUP'
      },

      // 列表table数据
      tableData: {
        total: 0,
        page: 1,
        rows: 20,
        data: []
      },
      // 验证规则
      rules: {
        xsRules: {
          place_name: [
            { required: true, message: '请输入渠道名称', trigger: 'blur' },
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          place_name_other: [
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          advertiser_id: [
            { required: true, message: '请选择账户', trigger: 'change' }
          ],
          page_url: [
            { required: true, message: '请填写落地页', trigger: 'blur' }
          ],
          follow: [
            { required: true, message: '请选择追踪方式', trigger: 'change' }
          ],
          changes: [
            {
              required: function(rule, value, callback) {
                if (this.xsForm.follow) {
                  return true
                }
                return false
              },
              message: '请选择转化目标',
              trigger: 'change'
            }
          ],
          novel: [
            {
              required: function(rule, value, callback) {
                if (this.addForm.isNovel == 'YES') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'change'
            }
          ],
          code: [
            {
              required: function(rule, value, callback) {
                if (this.addForm.run_type == 'RUN') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'blur'
            }
          ],
          live_track_url: [
            { required: true, message: '请填写监测链接', trigger: 'blur' }
          ]
        },
        zhRules: {
          follow: [
            { required: true, message: '请选择追踪方式', trigger: 'change' }
          ],
          changes: [
            { required: true, message: '请选择转化目标', trigger: 'change' }
          ]
        },
        copyRules: {
          place_name: [
            { required: true, message: '请输入渠道名称', trigger: 'blur' },
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          place_name_other: [
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ]
        },
        addRules: {
          advertiser_id: [
            { required: true, message: '请选择账户', trigger: 'change' }
          ],
          place_name: [
            { required: true, message: '请输入渠道名称', trigger: 'blur' },
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          place_name_other: [
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          app_type: [
            { required: true, message: '请选择APP类型', trigger: 'change' }
          ],
          application: [
            { required: true, message: '请选择应用', trigger: 'change' }
          ],
          follow: [
            { required: true, message: '请选择追踪方式', trigger: 'change' }
          ],
          changes: [
            {
              required: function(rule, value, callback) {
                if (this.addForm.follow) {
                  return true
                }
                return false
              },
              message: '请选择转化目标',
              trigger: 'change'
            }
          ],
          novel: [
            {
              required: function(rule, value, callback) {
                if (this.addForm.isNovel == 'YES') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'change'
            }
          ],
          code: [
            {
              required: function(rule, value, callback) {
                if (this.addForm.run_type == 'RUN') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'blur'
            }
          ],
          live_track_url: [
            // { required: true, message: '请填写监测链接', trigger: 'blur' },
          ]
        },
        yyRukes: {
          advertiser_id: [
            { required: true, message: '请选择账户', trigger: 'change' }
          ],
          place_name: [
            { required: true, message: '请输入渠道名称', trigger: 'blur' },
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          place_name_other: [
            {
              min: 3,
              max: 50,
              message: '名称长度在 3 到 50 个字符',
              trigger: 'blur'
            }
          ],
          app_type: [
            { required: true, message: '请选择APP类型', trigger: 'change' }
          ],
          application: [
            { required: true, message: '请选择应用', trigger: 'change' }
          ],
          follow: [
            { required: true, message: '请选择追踪方式', trigger: 'change' }
          ],
          changes: [
            {
              required: function(rule, value, callback) {
                if (this.yyForm.follow) {
                  return true
                }
                return false
              },
              message: '请选择转化目标',
              trigger: 'change'
            }
          ],
          novel: [
            {
              required: function(rule, value, callback) {
                if (this.yyForm.isNovel == 'YES') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'change'
            }
          ],
          code: [
            {
              required: function(rule, value, callback) {
                if (this.yyForm.run_type == 'RUN') {
                  return true
                } else {
                  return false
                }
              },
              message: '请选择应用',
              trigger: 'blur'
            }
          ],
          live_track_url: [
            { required: true, message: '请填写监测链接', trigger: 'blur' }
          ],
          h5_url: [{ required: true, message: '请填写H5链接', trigger: 'blur' }]
        }
      }
    }
  },
  // 数据监听
  watch: {
    'addForm.changes': function(newValue, oldValue) {
      if (newValue) {
        this.options.changes_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.addForm.changes_name = item.label
            }
          }.bind(this)
        )
      } else {
        this.addForm.changes_name = ''
      }
    },
    'xsForm.changes': function(newValue, oldValue) {
      if (newValue) {
        this.options.changes_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.xsForm.changes_name = item.label
            }
          }.bind(this)
        )
      } else {
        this.xsForm.changes_name = ''
      }
    },
    'yyForm.changes': function(newValue, oldValue) {
      if (newValue) {
        this.options.changes_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.yyForm.changes_name = item.label
            }
          }.bind(this)
        )
      } else {
        this.yyForm.changes_name = ''
      }
    },
    'addForm.application': function(newValue, oldValue) {
      if (newValue) {
        this.options.application_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.addForm.application_name = item.label
            }
          }.bind(this)
        )
      } else {
        this.addForm.application_name = ''
      }
    },
    'yyForm.application': function(newValue, oldValue) {
      if (newValue) {
        this.options.application_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.yyForm.application_name = item.label
            }
          }.bind(this)
        )
      } else {
        this.yyForm.application_name = ''
      }
    },
    'addForm.isAppDownload': function(newValue, oldValue) {
      if (newValue.length <= 0) {
        this.addForm.app = []
      }
    },
    'yyForm.isAppDownload': function(newValue, oldValue) {
      if (newValue.length <= 0) {
        this.yyForm.app = []
      }
    },
    'addForm.page': function(newValue, oldValue) {
      if (newValue) {
        this.options.page_options.forEach(
          function(item, index) {
            if (item.value == newValue) {
              this.addForm.page_url = item.url
            }
          }.bind(this)
        )
      } else {
        this.addForm.page_url = ''
      }
    }
  },
  methods: {
    //编辑功能
    editPlace: function(id, form, drawer) {
      this.$api.get(
        'release/getPlaceInfo',
        { id: id, type: this.form.type },
        res => {
          if (res.code == '0') {
            var newForm = res.data.other
            newForm['id'] = res.data.id
            this[form] = newForm

            this.title = '修改渠道'
            this.zhForm.follow = this[form].follow
            this.zhForm.changes = this[form].changes
            this.getApplicationInfo(this[form]['advertiser_id'])
            this[drawer] = true
          } else {
            this.$message.error(res.message)
          }
        }
      )
    },
    //复制渠道弹窗打开
    copyPlace: function(id) {
      this.copyDialog = true
      this.copyId = id
    },
    // 复制功能
    copyAction: function(form) {
      var parmas = this.copyForm
      parmas['id'] = this.copyId
      parmas['type'] = this.form.type
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            this.$api.post('release/copyPlace', parmas, res => {
              if (res.code == '0') {
                this.copyDialog = false
                this.handleSearch('')

                this.$message.success('您成功复制了一条渠道信息！')
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }.bind(this)
      )
    },
    //删除渠道
    delPlace: function(id) {
      this.$confirm('此操作将永久删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.get(
            'release/delPlace',
            { id: id, type: this.form.type },
            res => {
              if (res.code == '0') {
                this.tableData.data.forEach(
                  function(item, index) {
                    if (item.id == id) {
                      this.tableData.data.splice(index, 1)
                    }
                  }.bind(this)
                )
                this.$message.success('您成功删除了一条渠道信息！')
              } else {
                this.$message({ type: 'error', message: res.message })
              }
            }
          )
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除操作' })
        })
    },
    canelGoal: function() {
      var formField = ''
      if (this.form.type == '2') {
        formField = 'addForm'
      } else if (this.form.type == '5') {
        formField = 'xsForm'
      } else if (this.form.type == '7') {
        formField = 'yyForm'
      }

      this[formField]['follow'] = ''
      this[formField]['changes'] = ''

      this.goalDialog = false
    },
    addGoal: function(form) {
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            var formField = ''
            if (this.form.type == '2') {
              formField = 'addForm'
            } else if (this.form.type == '5') {
              formField = 'xsForm'
            } else if (this.form.type == '7') {
              formField = 'yyForm'
            }
            this[formField]['follow'] = this.zhForm.follow
            this[formField]['changes'] = this.zhForm.changes
            this.goalDialog = false
          }
        }.bind(this)
      )
    },
    //插入数据
    addToText: function(tag, form, field) {
      var str = '{' + tag + '}'
      var index = this[form][field].indexOf(str)

      if (index != -1) {
        this[form][field] = this[form][field].replace(str, '')
      } else {
        var id = this.selectionStart

        if (id < this[form][field].length) {
          //光标之前内容
          var strFront = this[form][field].substring(0, id)
          var strBehind = this[form][field].substring(
            id,
            this[form][field].length
          )

          this[form][field] = strFront + str + strBehind
        } else {
          this[form][field] += str
        }
      }
    },
    //获取焦点
    handleInputBlur: function(event) {
      var obj = event.srcElement ? event.srcElement : event.target
      if (obj.selectionStart && obj.selectionStart != 'undefind') {
        this.selectionStart = obj.selectionStart
      }
    },
    submitInfo: function(form, drawer) {
      this.$refs[form].validate(
        function(valid) {
          if (valid) {
            this.$api.post('release/editPlaceInfo', this[form], res => {
              if (res.code == '0') {
                this[drawer] = false
                this.handleSearch('')
                this.$message.success('您的内容已提交成功！')
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }.bind(this)
      )
    },
    handleSearch: function(event, page, prop, order) {
      this.loading = true

      if (!page) {
        page = 1
      }

      if (!prop) {
        prop = 'id'
      }

      if (!order) {
        order = 'desc'
      }
      this.$api.get(
        'release/getCanalList',
        {
          type: this.form.type,
          page: page,
          prop: prop,
          order: order,
          rows: this.tableData.per_page,
          advertiser_id: this.form.advertiser_id,
          place_name: this.form.name
        },
        res => {
          if (res.code == '0') {
            this.tableData = res.data.data
            this.loading = false
          } else {
            var message = '服务器数据异常！'
            if (res.message) {
              message = res.message
            }
            this.$notify({
              title: '警 告',
              message: message,
              type: 'warning'
            })
            this.loading = false
          }
        }
      )
    },
    //打开转化目标
    openGoal: function(form) {
      this.goalDialog = true
      this.changes_options = []
      this.formName = form
      this.getZhuanhuaInfo()
    },
    // 打开新建渠道
    addKsInfo: function() {
      this.title = '新建渠道'

      if (this.form.type == '2') {
        this.drawer = true
        this.addForm = {
          type: '2',
          advertiser_id: '',
          place_name: '',
          place_name_other: '',
          app_type: '',
          application: '',
          application_name: '',
          isAppDownload: [],
          app: [],
          follow: '',
          changes: '',
          changes_name: '',
          isNovel: 'NO',
          live_track_url: '',
          actionbar_click_url: '',
          novel: '',
          page: '',
          page_url: '',
          url: '',
          run_type: 'NO',
          code: '',
          codeType: 'ADGROUP'
        }
      } else if (this.form.type == '5') {
        this.xsDrawer = true
        this.xsForm = {
          type: '5',
          advertiser_id: '',
          place_name: '',
          place_name_other: '',
          scope_type: 'NONE',
          url_type: 'NONE',
          page_url: '',
          isPage: [],
          follow: '',
          changes: '',
          changes_name: '',
          isNovel: 'NO',
          novel: '',
          live_track_url: '',
          actionbar_click_url: '',
          run_type: 'NO',
          code: '',
          codeType: 'ADGROUP'
        }
      } else if (this.form.type == '7') {
        this.yyDrawer = true
        this.yyForm = {
          type: '7',
          advertiser_id: '',
          place_name: '',
          place_name_other: '',
          app_type: '',
          application: '',
          application_name: '',
          isAppDownload: [],
          app: [],
          follow: '',
          changes: '',
          changes_name: '',
          isNovel: 'NO',
          novel: '',
          live_track_url: '',
          actionbar_click_url: '',
          dq_url: '',
          h5_url: '',
          run_type: 'NO',
          code: '',
          codeType: 'ADGROUP'
        }
      }
    },
    //远程搜索账户
    remoteMethodAccount: function(query) {
      this.getAccountInfo(query)
    },
    //提交前数据整理
    otherInfo: function() {
      for (let key in this.addForm) {
        if (this.options[key + '_options']) {
          var data = this.options[key + '_options']
          data.forEach(
            function(item, index) {
              if (item.value == this.addForm[key]) {
                this.addForm.other[key] = item
              }
            }.bind(this)
          )
        }
      }
    },
    //获取下载详情页
    getPageInfo() {
      if (this.addForm.advertiser_id) {
        this.$api.get(
          'release/getPageList',
          {
            accountId: this.addForm.advertiser_id
          },
          res => {
            if (res.code == '0') {
              this.options.page_options = res.data
            } else {
              this.$message.error(res.message)
            }
          }
        )
      } else {
        this.options.pages = []
      }
    },
    // 获取小说
    getNovelInfo(form) {
      if (this[form]['advertiser_id'] && this[form]['isNovel'] == 'YES') {
        this.$api.get(
          'release/getFictionList',
          {
            accountId: this[form]['advertiser_id']
          },
          res => {
            if (res.code == '0') {
              this.options.novel_options = res.data
            } else {
              this.$message.error(res.message)
            }
          }
        )
      } else {
        this.options.novels = []
      }
    },
    //获取应用
    getApplicationInfo(value) {
      if (!value) {
        this.options.applications = []
      } else {
        this.$api.get('release/getAppList', { accountId: value }, res => {
          if (res.code == '0') {
            this.options.application_options = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    //获取转化目标
    getZhuanhuaInfo() {
      var form = this.formName
      if (this[form]['advertiser_id']) {
        this.$api.get(
          'release/getConvert',
          { accountId: this.addForm.advertiser_id, type: this.zhForm.follow },
          res => {
            if (res.code == '0') {
              this.options.changes_options = res.data
            } else {
              this.$message.error(res.message)
            }
          }
        )
      }
    },
    //获取账户下拉
    getAccountInfo: function(query) {
      this.$api.get('adPromotion/getAdvertiserInfo', { query: query }, res => {
        if (res.code == '0') {
          this.options.account_options = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    tabclick: function(value) {
      this.handleSearch(1)
    },
    handleCurrentChange: function(page) {
      this.handleSearch(page)
    }
  },
  //页面初始化
  mounted() {
    // 获取账户信息
    this.getAccountInfo('')
    this.handleSearch(1)
  }
}
</script>
<style scoped>
.ks_content {
  background: #fff;
}
.ks_toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ks_toolbar .title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
}
.ks_toolbar .title span {
  font-size: 12px;
  color: #999;
  font-weight: normal;
  margin-left: 10px;
}
</style>